import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(() => ({
  customerListViewWrapper: {
    paddingTop: 0,
    margin: '0 auto',
    paddingBottom: 100
  },
  usersHeader: {
    color: "black", 
    fontSize: "35px !important", 
    lineHeight: "50px",
    paddingBottom: '5px',
    textAlign: 'center'
  },
  modalTitle: {
    color: "black", 
    fontSize: "16px !important",
    textAlign: 'center'
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  tableCell: {
    padding: 15,
  },
  signupBanner: {
    marginTop: 45,
    backgroundColor: '#ff4949',
    padding: 30,
    marginBottom: 40,
    color: 'white'
  },
  actionButtonsWrapper: {
    display: 'flex',
    flexDirection: 'row'
  },
  modalBody: {
    top: '50%',
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '15px',
    backgroundColor: 'white',
    border: 0,
    "@media (max-width: 650px)": {
      width: '90%'
    }
  },
}));